import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { codeSnippetAPI } from '../services/api';

function AccessCodeSnippet() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!code.trim()) {
      setError('Please enter a code');
      return;
    }

    if (code.trim().length !== 6) {
      setError('Code must be 6 characters');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await codeSnippetAPI.getSnippetByCode(code.trim().toUpperCase());
      // Navigate to the viewer page with the snippet ID
      navigate(`/code-snippet/view/${response.data.snippet._id}`);
    } catch (err) {
      console.error('Error accessing snippet:', err);
      setError(err.response?.data?.message || 'Failed to access snippet. Please check the code and try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCodeChange = (e) => {
    // Convert to uppercase and limit to 6 characters
    const value = e.target.value.toUpperCase().slice(0, 6);
    setCode(value);
    setError('');
  };

  return (
    <div className="container" style={{ maxWidth: '600px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '40px'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '16px'
          }}>
            💻
          </div>
          <h2 style={{
            fontSize: '28px',
            fontWeight: '600',
            color: '#1a202c',
            margin: '0 0 8px 0'
          }}>
            Access Code Snippet
          </h2>
          <p style={{
            fontSize: '16px',
            color: '#718096',
            margin: 0
          }}>
            Enter the 6-digit code to view the code snippet
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#4a5568',
              marginBottom: '8px'
            }}>
              Snippet Code
            </label>
            <input
              type="text"
              value={code}
              onChange={handleCodeChange}
              placeholder="ABC123"
              style={{
                width: '100%',
                padding: '16px',
                fontSize: '24px',
                fontWeight: '600',
                textAlign: 'center',
                letterSpacing: '4px',
                border: error ? '2px solid #f56565' : '2px solid #e2e8f0',
                borderRadius: '8px',
                outline: 'none',
                fontFamily: 'monospace',
                textTransform: 'uppercase'
              }}
              onFocus={(e) => {
                if (!error) e.target.style.borderColor = '#667eea';
              }}
              onBlur={(e) => {
                if (!error) e.target.style.borderColor = '#e2e8f0';
              }}
              disabled={loading}
            />
            {error && (
              <p style={{
                color: '#f56565',
                fontSize: '14px',
                marginTop: '8px',
                marginBottom: 0
              }}>
                {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading || !code.trim()}
            className="submit-button"
            style={{
              width: '100%',
              padding: '16px',
              fontSize: '16px',
              fontWeight: '600',
              color: 'white',
              background: loading || !code.trim() ? '#cbd5e0' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none',
              borderRadius: '8px',
              cursor: loading || !code.trim() ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s'
            }}
          >
            {loading ? (
              <>
                <span style={{ display: 'inline-block', animation: 'spin 1s linear infinite' }}>⏳</span>
                {' '}Accessing...
              </>
            ) : (
              'Access Snippet'
            )}
          </button>
        </form>

        {/* Info Section */}
        <div style={{
          marginTop: '32px',
          padding: '16px',
          background: '#f7fafc',
          borderRadius: '8px',
          border: '1px solid #e2e8f0'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#4a5568',
            margin: 0,
            lineHeight: '1.6'
          }}>
            <strong>📌 Note:</strong> The code should be a 6-character alphanumeric code provided by your instructor. Make sure to enter it exactly as provided.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .submit-button:not(:disabled):hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
        }
      `}</style>
    </div>
  );
}

export default AccessCodeSnippet;
